require('../../modules/es6.symbol');
module.exports = require('../../modules/$.core').Symbol['for'];


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/for.js
// module id = 1524
// module chunks = 0